import { Link } from 'react-router-dom';
import styles from './giver-responsibility.module.less';
import {
    ACCEPTING_TEXT_KEY,
    AND_TEXT_KEY,
    EMAIL_IS_SHARED_WITH_OWNER_TEXT_KEY,
    PRIVACY_POLICY_TEXT_KEY,
    STANDARD_GIVER_RESPONSIBILITY_TEXT_KEY,
    TERMS_TEXT_KEY,
} from '../../i18n/project-i18n-model';
import I18nText from '../../i18n/I18nText';

export const GiverResponsibility = ({ showRewardText = false }) => {
    return (
        <div className={styles.giverResponsibility}>
            {showRewardText ? (
                <ul>
                    <li>
                        &#x2022; <I18nText textKey={EMAIL_IS_SHARED_WITH_OWNER_TEXT_KEY} />
                    </li>
                    <br />
                    <li>
                        &#x2022; <I18nText textKey={STANDARD_GIVER_RESPONSIBILITY_TEXT_KEY} />
                    </li>
                </ul>
            ) : (
                <p>
                    <I18nText textKey={STANDARD_GIVER_RESPONSIBILITY_TEXT_KEY} />
                </p>
            )}
            <br />
            <p>
                <I18nText textKey={ACCEPTING_TEXT_KEY} />{' '}
                <Link to={'/vilkar'} target={'_blank'}>
                    <I18nText textKey={TERMS_TEXT_KEY} />
                </Link>{' '}
                <I18nText textKey={AND_TEXT_KEY} />{' '}
                <Link to={'/personvern'} target={'_blank'}>
                    <I18nText textKey={PRIVACY_POLICY_TEXT_KEY} />
                </Link>
            </p>
        </div>
    );
};
